import { Component, OnInit, ViewChild, Output, EventEmitter, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { DashboardService } from 'src/app/shared/services/dashboard.service';

import * as XLSX from 'xlsx';

@Component({
  selector: 'app-history-table',
  templateUrl: './history-table.component.html',
  styleUrls: ['./history-table.component.less'],
  standalone: false
})
export class HistoryTableComponent implements OnInit, OnChanges, OnDestroy {

  @Output() handleTableRowClick = new EventEmitter<any>();
  @Input() data: any;
  @Input() currentPage: any;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  public displayedColumns: string[];
  public dataSource = new MatTableDataSource();
  public rowDatafromTable: any;
  public filterValue: any;
  public downloadSubscription: any;
  public fileName = 'ExcelSheet.xlsx';
  crmApiUrl: any;
  userId: string;
  loggedInUserData: any;
  public crmAuthKey: string;

  constructor(
    private router: Router,
    public dashboardService: DashboardService,
  ) { }

  ngOnInit() {
    this.userId = localStorage.getItem('userId');
    this.loggedInUserData = JSON.parse(localStorage.getItem('loggedInUserData'));
    this.crmApiUrl = this.loggedInUserData.envConfig.crmUrl;
    this.crmAuthKey = this.loggedInUserData.envConfig.crmAuthKey;
    this._populateTable();

    this.downloadSubscription = this.dashboardService.dashbaordSourceObservable.subscribe((data: any) => {
      if (data.downloadExcelSheet === true) {
        this.exportexcel(data.tableData);
      }
    });

  }

  ngOnChanges(changes: SimpleChanges) {
    this._populateTable();
  }

  private _populateTable() {
    if (this.currentPage === 'acn') {
      this.displayedColumns = ['vinNumber', 'ticketId', 'agentId', 'vehRegNumber', 'eventstartTime', 'customerInfo'];
      this.dataSource = this.data;
    } else if (this.currentPage === 'acn-count') {
      this.displayedColumns = ['vinNumber', 'ticketId', 'agentId', 'vehRegNumber', 'eventstartTime', 'customerInfo'];
      this.dataSource = this.data;
    } else if (this.currentPage === 'svt') {
      this.displayedColumns = ['vinNumber', 'ticketId', 'agentId', 'vehRegNumber', 'createdOn', 'customerInfo'];
      this.dataSource = this.data;
    } else if (this.currentPage === 'mcall') {
      this.displayedColumns = ['vinNumber', 'ticketId', 'agentId', 'vehRegNumber', 'eventstartTime', 'warningLamp', 'customerInfo'];
      this.dataSource = this.data;
    } else if (this.currentPage === 'security-alert') {
      this.displayedColumns = ['vinNumber', 'vehRegNumber', 'eventstartTime', 'customerInfo'];
      this.dataSource = this.data;
    } else if (this.currentPage === 'mcall-count') {
      this.displayedColumns = ['vinNumber', 'ticketId', 'agentId', 'vehRegNumber', 'eventstartTime', 'warningLamp', 'customerInfo'];
      this.dataSource = this.data;
    } else if (this.currentPage === 'openTicketsCrm') {
      this.displayedColumns = ['TicketId', 'mode', 'openDate', 'lastUpdatedDate', 'status', 'customer_voice', 'view'];
      this.dataSource = this.data;
    } else if (this.currentPage === 'warning-lamp') {
      this.displayedColumns = ['vinNumber', 'vehRegNumber', 'eventStartTime', 'messageContent'];
      this.dataSource = this.data;
    }
    // this.dataSource = this.data;
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }


  exportexcel(data): void {
    /* table id is passed over here */
    const element = document.getElementById('historyTable');
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);

  }

  /**
   * navigate to map screen
   * @param rowData:any;
   */
  public navigate(rowData: any) {
    this.handleTableRowClick.emit(rowData);
  }

  ngOnDestroy() {
    this.downloadSubscription.unsubscribe();
  }

  /**
   * to sort the rows of table
   */
  // public customSort() {
  //   this.dataSource.sortingDataAccessor = (item, property) => {
  //     switch (property) {
  //       case 'vehRegNumber': return new Date(item.startEventDate);
  //       default: return item[property];
  //     }
  //   };
  // }

}
